import {z} from 'zod'
import {RouteAddressModel} from './route.js'
import time from '../utils/time.js'
import Colors from '../../utils/Colors.js'
import {OrderConditionGroupsModel} from './order.js'

const NewRouteTemplateModel = z.object({
    reseller: z.string().nonempty(),
    branchId: z.string().max(100).optional(),
    color: z.enum([...Colors.routeColors] as [string, ...string[]]).default(() => Colors.routeColors[Math.floor(Math.random() * Colors.routeColors.length)]),
    name: z.string().default(''),
    startDate: z.string().default(time.today()),
    endDate: z.string().optional(),
    rrule: z.string().default(''),
    messengerId: z.string().default(''),
    startTime: z.string().default(''),
    vehicleType: z.string().default(''),
    vehicleTypeId: z.string().default(''),
    vehicleId: z.string().default(''),
    stopTime: z.number().default(120),
    startPoint: RouteAddressModel.partial(),
    endPoint: RouteAddressModel.partial(),
    instructions: z.string().default(''),
    routeCalculation: z.object({
        maxStops: z.number().nullable().default(null),
        whenRouteFull: z.enum(['newRoute', 'ignoreRest']).default('newRoute'),
        whenRouteIsReady: z.enum(['addToRoute', 'newRoute', 'ignoreRest']).default('ignoreRest'),
        optimizeForTimeslots: z.boolean().default(false),
        adjustableByMessengerGrouped: z.enum(['default', 'yes', 'no']).default('default'),
        adjustableByMessenger: z.boolean().default(false),
        allowAddAddress: z.boolean().default(false),
        allowAddCollo: z.enum(['yes', 'deliver', 'pickup', '']).default(''),
        messengerAddOrderWarning: z.enum(['allowed', 'only_today', 'only_unplanned', 'only_unplanned_today', 'notallowed']).default('notallowed'),
        showWarningOnAddExistingOrder: z.boolean().default(false),
        allowMessengerEditCustomOptions: z.boolean().default(false)
    }).default({}),
    loadingRequiredBeforeStart: z.boolean().default(false),
    connectedRecurringOrders: z.array(z.string()).default([]),
    connectedRecurringOrdersAddresses: z.array(z.object({
        id: z.string(), // recurring order id with address index
        index: z.number()
    })).default([]),
    lockRecurringOrdersAddressesOrder: z.boolean().default(false),
    // Route automatisch vullen: orders that match the conditions are added to the route of the template on their date
    autoFill: z.boolean().default(false),
    autoFillRulesMatchAll: z.boolean().default(true),
    conditionGroups: OrderConditionGroupsModel,
    history: z.array(z.object({
        timestamp: z.string(),
        type: z.enum(['create', 'update']),
        who: z.string(),
        userId: z.string().optional(),
        description: z.string().optional()
    })).default([]),
    removed: z.boolean().default(false)
})

const RouteTemplateModel = NewRouteTemplateModel.extend({
    _id: z.string()
})

export {NewRouteTemplateModel, RouteTemplateModel}
